module.exports = __webpack_public_path__ + "assets/img/has.401f2700.png";